export default __webpack_public_path__ + "images/0f79e415733e93506f497bc17e7a2273.png";